import React, { useEffect } from 'react'
import './stayle.scss'
import moment from 'moment-jalaali'
// import { annualHoliday1402, createCalendar, enToPersianChar, tableHead } from '../../../components/helper'
// import { CCol, CFormInput, CFormSelect, CRow } from '@coreui/react'
// import CustomModal from '../../../components/CroreUIModal'
import { Holidays } from './holidays'
import CustomValuesHook from '../../Hooks/customValuesHook'
import { annualHoliday1402, createCalendar, getDateOfTimeZoneDate, getEnDate, tableHead } from '../../shared/helper'
import { enToPersianChar } from '../activities'
import ActionMenu from './actionMenu'
import { getHolidays } from '../../api/requestAxios/calendarHolidayRequests'
import { HolidayDataObjectList, HolyDayType } from '../../types/holiday/types'
import { Button, ButtonGroup } from 'react-bootstrap'
import { set } from 'date-fns-jalali'


const CouncilCalendar = () => {
    const [states, setStates] = CustomValuesHook({
        calendar: [],
        colSelecteds: [],
        cellSelecteds: [],
        holidays: [],
        displayAnnualEndWeek: true,
        displayEndWeek: true,
        selectedYear: '1402'
    })

    useEffect(() => {
        // createCalendar()
        handleCreateCalendar(states.selectedYear)
        getData()
    }, [])

    const handleCreateCalendar = (year: string) => {
        setStates({ calendar: [] })

        const calendar = createCalendar(moment, parseInt(year))
        setStates({ calendar: [...calendar] })
    }

    const getData = async () => {
        try {
            const response: { data: HolidayDataObjectList } = await getHolidays({
                pageNumber: 1,
                pageSize: 20,
                disablePaging: true,
                sortText: '',
                whereConditionText: ''
            });
            const sortedList = response.data.data.sort((a: HolyDayType, b: HolyDayType) => {
                return new Date(a.date).getTime() - new Date(b.date).getTime()
            })
            setStates({ holidays: sortedList })

        } catch (error) {

        }
    }

    const handleClickColumn = (colIdx: number) => {
        let calendar = [...states.calendar]
        let tempList = [...states.colSelecteds]
        clearCells(calendar)

        for (let i = 0; i < calendar.length; i++) {
            for (let j = 0; j < calendar[i].days.length; j++) {

                calendar[i].days[j].selectedByCol = false



            }

        }

        tempList.push(colIdx)
        setStates({ colSelecteds: [tempList] })
        for (let i = 0; i < calendar.length; i++) {
            for (let j = 0; j < calendar[i].days.length; j++) {
                if (j === colIdx) {
                    calendar[i].days[j].selectedByCol = true
                }
            }
        }
        setStates({ calendar: [...calendar] })
    }
    const handleClickCell = (e: any, cellItem: any, cell: any, rowIdx: number) => {
        let calendar = [...states.calendar]
        if (e) {
            e.preventDefault()
        }
        clearCells(calendar)
        let tempList = [...states.cellSelecteds]
        setStates({ cellSelecteds: [...tempList], calendar: [...calendar] })
    }

    const clearCells = (calendar: any) => {
        for (let i = 0; i < calendar.length; i++) {

            for (let j = 0; j < calendar[i].days.length; j++) {

                calendar[i].days[j].isOpenContextMenu = false


            }

        }
    }

    const handleRightClick = (e: any, cellItem: any, cell: number, rowIdx: number) => {
        e.preventDefault()

        let calendar = [...states.calendar]
        clearCells(calendar)
        if (calendar.length > 0) {
            calendar[rowIdx].days[cell].isOpenContextMenu = true;
            setStates({ calendar: [...calendar] })
        }

    }



    return (
        <div className='council-calendar-page'>

            <div className='content-container' >
                <div className='context-head' >
                    <b> تقویم شورا</b>

                </div>
                <div className='calendar-context'>
                    <div className='p-3 my-2'>
                        <div className='d-flex'>
                            <div className='form-group mx-2' >
                                <select className='form-control form-select'
                                    value={states.selectedYear}
                                    onChange={(e) => {
                                        const year = e.target.value
                                        setStates({ selectedYear: year });
                                        handleCreateCalendar(year)
                                    }} >
                                    <option value="1402" >{enToPersianChar('1402')}</option>
                                    <option value="1403" >{enToPersianChar('1403')}</option>
                                    <option value="1404" >{enToPersianChar('1404')}</option>


                                </select>
                            </div>
                            <div>
                                <ButtonGroup aria-label="Basic example">
                                    <Button variant={states.displayEndWeek ? 'success' : "secondary"} onClick={() => setStates({ displayEndWeek: !states.displayEndWeek })} >نمایش  جمعه ها</Button>
                                    <Button variant={states.displayAnnualEndWeek ? 'success' : "secondary"} onClick={() => setStates({ displayAnnualEndWeek: !states.displayAnnualEndWeek })}>نمایش  تعطیلات رسمی</Button>
                                </ButtonGroup>
                            </div>
                            <p className='hint-p' >برای ورود ، ویرایش  تعطیلات رسمی روی تاریخ مورد نظر راست کلیک کنید.</p>
                        </div>

                    </div>
                    <table className='table table-bordered'>
                        <thead>
                            <tr>
                                <th>ماه/هفته</th>
                                {tableHead.map((item, idx) =>
                                    <th className={`${states?.colSelecteds?.some((i: any) => i === idx) ? 'selected-col' : ''}`}
                                        onClick={() => handleClickColumn(idx)} key={idx} >{item}</th>)}
                            </tr>

                        </thead>
                        <tbody>
                            {states.calendar.map((item: any, idx: number) => <tr key={idx}>
                                <td>{item.month}</td>
                                {item.days.map((day: any, _idx: number) =>
                                    <td
                                        key={_idx}
                                        onClick={(e) => handleClickCell(e, day, _idx, idx)}
                                        className={`${(states.displayEndWeek && day.dayNumber === 5) ||
                                            (states.displayAnnualEndWeek && states.holidays.some((i: any) => getDateOfTimeZoneDate(i.date) === getEnDate(day.dateStr))) ? 'holiday' : ''}
                                             ${day.selectedByCol ? 'selected-by-col' : ''} ${day.selectedBySell ? 'selected-by-cel' : ''}`}
                                        onContextMenu={(e) => handleRightClick(e, day, _idx, idx)}
                                    >

                                        {enToPersianChar(day.day)}
                                        {day.isOpenContextMenu && <div className='context-menu'
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                setStates({ displayModal: true });
                                            }}>
                                            <ActionMenu
                                                clearMenu={() => handleClickCell(undefined, day, _idx, idx)}
                                                getHolidays={getData}
                                                holidays={states.holidays}
                                                day={day} />
                                        </div>}


                                    </td>)}
                            </tr>)}
                        </tbody>
                    </table>
                </div>
                <Holidays holidays={states.holidays} selectedYear={states.selectedYear} />
            </div>
        </div>
    )
}

export default CouncilCalendar